import { type EdgeProps } from '@xyflow/react'
import { FlowCustomEdge } from 'widgets/Flow'
import { AddActionDropdownContent } from './AddActionDropdownContent/AddActionDropdownContent'

export function CustomEdge(props: EdgeProps & { viewOnly?: boolean }) {
  return <FlowCustomEdge {...props} Content={AddActionDropdownContent} />
}
